import {DateTime} from 'util/time';
import {CurrencyAmount} from 'util/currency';


export enum SpaceEventType {
  Retail = 'retail',
  Event = 'event'
}

export interface SpaceEventSpace {
  name: string;
  code: string;
  //currency: Currency;
}

export interface SpaceEventBase {
  name: string;
  description: string;
  type: SpaceEventType;
  link: URL|null;
}

export interface NewSpaceEvent extends SpaceEventBase {
  heroImage: File|null;
  entryCost: number|null;
}

export interface UpdatedSpaceEvent extends SpaceEventBase {
  heroImage: File|undefined|null;
  entryCost: number|null;
}

export interface SpaceEvent extends SpaceEventBase {
  space: SpaceEventSpace;
  code: string;
  startTime: DateTime;
  endTime: DateTime;
  heroImage: URL|null;
  entryCost: CurrencyAmount|null;
}